import { Column } from '@ant-design/charts'
import { Col, Row } from 'antd'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'
import styled from 'styled-components'

const UserActivityTabDashboardStyled = styled.div`
    background-color: white;

    .ant-tabs-tab {
        padding: 16px 0;
        font-size: 16px;
        font-weight: 400;
        line-height: 24px;
    }
    .ant-tabs-nav-wrap {
        margin-left: 24px;
    }
    .title-sale-tab {
        width: 100%;
        margin-bottom: 20px;

        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
    }
`

export default function UserActivityTabDashboard({ dataActivity, getTypeLabel }) {
  const [trans] = useTranslation(['dashboard'])

  const [dataUserActivity, setDataUserActivity] = useState([])
  const config = {
    data: dataUserActivity,
    xField: 'type',
    yField: 'value',
    height: 254,
    xAxis: {
      line: { style: {
        stroke: '#6d6d6d',
        shadowColor: '#6d6d6d'
      } }
    },
    columnStyle: {
      fill: '#58AFFF'
    },
    maxColumnWidth: 50,
    yAxis: {
      tickCount: 10
    },
    label: {
      content: ''
    }
  }

  useEffect(() => {
    if (dataActivity) {
      const arrData = []
      if (dataActivity?.length > 0) {
        for (let i = 0; i < dataActivity?.length; i += 1) {
          const item = {
            value: dataActivity[i].activityCount,
            type: getTypeLabel(dataActivity[i])
          }
          arrData.push(item)
        }
      }
      setDataUserActivity(arrData)
    }
  }, [dataActivity])
  return (
    <UserActivityTabDashboardStyled>
      <Row>
        <Col sm={0} xl={4} />
        <Col sm={24} xl={16}>
          <div className="title-sale-tab">
            <span>{trans('dashboard:MAUTrend')}</span>
          </div>
          <Column {...config} />
        </Col>
        <Col sm={0} xl={4} />
      </Row>
    </UserActivityTabDashboardStyled>
  )
}

UserActivityTabDashboard.propTypes = {
  dataActivity: PropTypes.array,
  getTypeLabel: PropTypes.func
}
